import { useEffect, useState } from "react";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import CoinIcon from "@/components/CoinIcon";
import api from "@/lib/api";
import { formatTRY, formatDate, truncate } from "@/lib/format";

export default function AdminTransactions() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/transactions").then(({ data }) => setItems(data.transactions)).catch(() => setItems([])); }, []);
  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="İşlemler" desc="Platform genelinde onaylanan tüm işlemler." />
      {items.length === 0 ? <EmptyState title="İşlem yok" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["İşlem ID", "Merchant", "Tutar (₺)", "Kripto", "Coin/Ağ", "Komisyon", "Net", "Hash", "Tarih"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border" data-testid="admin-transactions-table">
                {items.map((t) => (
                  <tr key={t.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-mono text-xs">{truncate(t.id, 6)}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{t.merchant_email}</td>
                    <td className="px-4 py-3 font-semibold">{formatTRY(t.amount_try)}</td>
                    <td className="px-4 py-3">{Number(t.crypto_amount).toFixed(6)}</td>
                    <td className="px-4 py-3"><span className="inline-flex items-center gap-1.5"><CoinIcon symbol={t.coin} size={16} /> {t.coin}·{t.network}</span></td>
                    <td className="px-4 py-3 text-amber-500">{Number(t.commission).toFixed(6)}</td>
                    <td className="px-4 py-3 font-medium">{Number(t.net_amount).toFixed(6)}</td>
                    <td className="px-4 py-3 font-mono text-xs">{truncate(t.tx_hash || "-", 6)}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{formatDate(t.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
